import styled from 'styled-components'

export const CategoryFilterWrapper = styled.div`
  min-width: 380px;
`
